import React, { useState, useEffect, useContext } from 'react';
import styles from "../../../styles/components/Modal/Payments/SettingsModal.module.css"
import { LangContext } from '../../../context/LangContext';
import { ThemeContext } from '../../../context/ThemeContext';

const translations = {
    ru: {
        title: "Настройки отображения",
        highlightRows: "Подсвечивать строки со статусами:",
        success: "Успешно",
        process: "В процессе",
        fail: "Отказ",
        canceled: "Отменено",
        waitaccept: "Ожидает подтверждения",
        save: "Сохранить",
        close: "Закрыть",
        reset: "Сбросить"
    },
    en: {
        title: "Display Settings",
        highlightRows: "Highlight rows with statuses:",
        success: "Success",
        process: "In Process",
        fail: "Failed",
        canceled: "Canceled",
        waitaccept: "Pending",
        save: "Save",
        close: "Close",
        reset: "Reset"
    },
};

export const SettingsModal = ({ onClose, onSave }) => {
    const { langSelected } = useContext(LangContext);
    const { theme } = useContext(ThemeContext);
    const currentTranslation = translations[langSelected] || translations.ru;
    const [selectedStatuses, setSelectedStatuses] = useState([]);

    useEffect(() => {
        const storedSettings = localStorage.getItem('highlightedStatuses');
        if (storedSettings) {
            try {
                setSelectedStatuses(JSON.parse(storedSettings));
            } catch (error) {
                setSelectedStatuses([]);
            }
        }
    }, []);

    const handleCheckboxChange = (status) => {
        setSelectedStatuses(prev => {
            if (prev.includes(status)) {
                return prev.filter(s => s !== status);
            } else {
                return [...prev, status];
            }
        });
    };

    const handleSave = () => {
        localStorage.setItem('highlightedStatuses', JSON.stringify(selectedStatuses));
        onSave(selectedStatuses);
        onClose();
    };

    const handleReset = () => {
        setSelectedStatuses([]);
        localStorage.removeItem('highlightedStatuses');
        onSave([]);
        onClose();
    };

    const statuses = [
        { key: 'success', label: currentTranslation.success },
        { key: 'process', label: currentTranslation.process },
        { key: 'fail', label: currentTranslation.fail },
        { key: 'canceled', label: currentTranslation.canceled },
        { key: 'waitaccept', label: currentTranslation.waitaccept },
    ];
    
    const modalContentClass = `${styles.modalContent} ${theme === 'dark' ? styles.darkModalContent : ''}`;
    const modalHeaderClass = `${styles.modalHeader} ${theme === 'dark' ? styles.darkModalHeader : ''}`;
    const modalHeaderH3Class = `${styles.modalHeader} ${styles.h3} ${theme === 'dark' ? styles.darkModalHeaderH3 : ''}`;
    const closeButtonClass = `${styles.closeButton} ${theme === 'dark' ? styles.darkCloseButton : ''}`;
    const modalBodyPClass = `${styles.modalBody} ${styles.p} ${theme === 'dark' ? styles.darkModalBodyP : ''}`;
    const checkboxTextClass = `${styles.checkboxText} ${theme === 'dark' ? styles.darkCheckboxText : ''}`;
    const modalFooterClass = `${styles.modalFooter} ${theme === 'dark' ? styles.darkModalFooter : ''}`;
    const saveButtonClass = `${styles.button} ${styles.saveButton} ${theme === 'dark' ? styles.darkSaveButton : ''}`;
    const resetButtonClass = `${styles.button} ${styles.resetButton} ${theme === 'dark' ? styles.darkResetButton : ''}`;


    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={modalContentClass} onClick={(e) => e.stopPropagation()}>
                <div className={modalHeaderClass}>
                    <h3 className={modalHeaderH3Class}>{currentTranslation.title}</h3>
                    <button className={closeButtonClass} onClick={onClose}>&times;</button>
                </div>
                <div className={styles.modalBody}>
                    <p className={modalBodyPClass}>{currentTranslation.highlightRows}</p>
                    <div className={styles.checkboxGroup}>
                        {statuses.map(status => (
                            <label key={status.key} className={styles.checkboxLabel}>
                                <input
                                    type="checkbox"
                                    checked={selectedStatuses.includes(status.key)}
                                    onChange={() => handleCheckboxChange(status.key)}
                                    className={theme === 'dark' ? styles.darkCheckbox : ''}
                                />
                                <span className={checkboxTextClass}>{status.label}</span>
                            </label>
                        ))}
                    </div>
                </div>
                <div className={modalFooterClass}>
                    <button className={resetButtonClass} onClick={handleReset}>
                        {currentTranslation.reset}
                    </button>
                    <button className={saveButtonClass} onClick={handleSave}>
                        {currentTranslation.save}
                    </button>
                </div>
            </div>
        </div>
    );
};